import { render, staticRenderFns } from "./ResourceMetaData.vue?vue&type=template&id=2d768eb4"
import script from "./ResourceMetaData.vue?vue&type=script&lang=js"
export * from "./ResourceMetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports